export default __webpack_public_path__ + "static/media/eu.db4cf6e6.jpg";